import strawberries from "../../image/blog/strawberries.jpg";
import pepper from "../../image/blog/pepper/02.jpg";
import eggplant from "../../image/blog/eggplant/6.jpg";
import grapes from "../../image/blog/grapes.jpg";
import blueberry from "../../image/blog/blueberry.jpg";
import potato from "../../image/blog/potato.png";
import cucumbers from "../../image/blog/cucumber.png";
import nutrition from "../../image/blog/nutrition.jpeg";
import rye from "../../image/blog/main-rye.png";
import pea from "../../image/blog/main-pea.png";

export const items = [
    {
        title: 'Добрива для Жита',
        desc: 'Жито посівне — рослина родини тонконогових, близько пов`язана з ячменем та пшеницею, що широко вирощується людиною для отримання зерна та як кормова культура...',
        class: 'blog__col',
        date: '02.04.2026',
        visability: '0',
        button: 'rye',
        slug: "rye",
        img: rye,
        link: 'rye',
        id: "10"
    },
    {
        title: 'Добрива для Гороху',
        desc: 'Горох є однією з найважливіших культур у сівозміні, адже поєднує економічну вигоду з агрономічною цінністю. Його ключова перевага - здатність фіксувати атмосферний азот завдяки симбіозу з бульбочковими бактеріями...',
        class: 'blog__col',
        date: '02.04.2026',
        visability: '0',
        button: 'pea',
        slug: "pea",
        img: pea,
        link: 'pea',
        id: "9"
    },
    {
        title: 'Добрива для Перцю',
        desc: 'Добриво Агроболік від компанії Санберрі Україна є чудовим вибором для підживлення перців. Це комплексне добриво містить необхідні поживні речовини, які сприяють здоровому росту, розвитку і плодоношенню рослин. Ось кілька причин, чому Агроболік може...',
        class: 'blog__col',
        date: '15.01.2026',
        visability: '23',
        button: 'pepper',
        slug: "pepper",
        img: pepper,
        link: 'pepper',
        id: "23"
    },
    {
        title: 'Добрива для Баклажану',
        desc: 'Баклажани - це чудова рослина, яка вирощується в багатьох садах та городах для отримання смачних та корисних плодів. Щоб забезпечити їм оптимальні умови для росту та розвитку, важливо використовувати відповідні...',
        class: 'blog__col',
        date: '18.02.2026',
        visability: '32',
        button: 'eggplant',
        slug: "eggplant",
        img: eggplant,
        link: 'eggplant',
        id: "32"
    },
    {
        title: 'Добрива для полуниці',
        desc: 'Солодку полуницю або, як її ще називають, садову суницю полюбляють і дорослі, і діти, тому охоче саджають та вирощують ягоди на присадибних ділянках та приватних фермах. Ретельно обираючи сорти за врожайністю, розміром плодів та їх смаковими якостями...',
        class: 'blog__col',
        date: '06.06.2025',
        visability: '601',
        button: 'strawberries',
        slug: "strawberries",
        img: strawberries,
        link: 'strawberries',
        id: "3"
    },
    {
        title: 'Добрива для Винограду',
        desc: 'Кожна рослина для свого нормального росту та життєдіяльності потребує поживних речовин, наприклад азоту, калію, кальцію, фосфору, магнію, сірки, заліза. Також в незначній кількості ще потрібні бор, цинк, мідь, марганець тощо.',
        class: 'blog__col1',
        date: '27.06.2025',
        visability: '158',
        button: 'grape',
        slug: "grapes",
        img: grapes,
        id: "4"
    },
    {
        title: 'Добриво для Лохини',
        desc: 'Лохина – корисна ягода, джерело величезної кількості вітамінів, зовні схожа на чорницю. Раніше скуштувати її свіжою можна було лише в лісах Карпат чи на Поліссі. Проте цю рослину часто обирають городники, охочі виростити на своїй ділянці щось екзотичне та незвичайне...',
        class: 'blog__col2',
        date: '22.07.2025',
        visability: '489',
        button: 'blueberry',
        slug: "blueberry",
        img: blueberry,
        id: "5"
    },
    {
        title: 'Добрива для Картоплі',
        desc: 'Картопля є однією з найважливіших та найпопулярніших культур у сільському господарстві. Вона присутня в кожному домі, її купують протягом усього року й використовують для приготування величезної кількості страв...',
        class: 'blog__col3',
        date: '09.09.2025',
        visability: '45',
        slug: "potato",
        img: potato,
        button: 'potato',
        id: "6"
    }, {
        title: 'Добрива для Огірків',
        desc: 'Кожен з городників, хто взявся за вирощування цих культур, прагне отримати гарний врожай. Але досягти цього не так просто, адже доводиться враховувати багато різноманітних факторів. Серед них стан ґрунту, температура повітря, термін посадки, полив...',
        class: 'blog__col4',
        date: '14.10.2025',
        visability: '98',
        slug: "cucumbers",
        img: cucumbers,
        button: 'cucumber',
        id: "7"
    }, {
        title: 'Роль елементів живлення в розвитку рослини',
        desc: 'Кожен з елементів живлення, які споживають рослини, відіграє свою роль в обміні речовин та в процесах росту і розвитку.',
        class: 'blog__col5',
        date: '18.10.2025',
        slug: "nutrition",
        img: nutrition,
        visability: '589',
        button: 'nutrition',
        id: "8"
    }
];
